<div class="form-group">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'header.currencies' | translate }} ({{ currencies ? currencies.length : '0' }})</label>
            <div class="table-items">
                <div class="item item-header">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start">{{'Enabled' | translate}}</div>
                        <div class="col-2 align-items-center justify-content-start">{{'ISO Code' | translate}}</div>
                        <div class="col-3 align-items-center justify-content-start">{{'Symbol' | translate}}</div>
                        <div class="col-3 align-items-center justify-content-end">{{'Show symbol before amount?' | translate}}</div>
                        <div class="col-2 align-items-center justify-content-end"></div>
                    </div>
                </div>
                <div class="item" *ngFor="let currency of currencies; let i = index; let last = last;">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start">
                            <i *ngIf="isLoading"
                                class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                aria-hidden="true"></i>
                            <i  class="fas icon-large {{currency.isEnabled ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"
                                (click)="toggleCurrency(currency);$event.stopPropagation();"
                                style="position:relative;top:2px;"></i>
                        </div>
                        <div class="col-2 align-items-center justify-content-start">
                            <span *ngIf="!editMode[i] || editType !== 'code'" (click)="editMode[i]=true;editType='code';$event.stopPropagation();" style="cursor:pointer;">{{currency.code | translate}}</span>
                            <form *ngIf="editMode[i] && editType === 'code'"
                                    (click)="$event.stopPropagation();"
                                    style="width:100%;display:flex;align-items:center;">
                                <input *ngIf="editMode[i]"
                                        class="form-control"
                                        type="text"
                                        name="code"
                                        [(ngModel)]="currency.code"
                                        placeholder="{{ 'annexes.currency.code_placeholder' | translate }}"
                                        #code="ngModel"
                                        [rangeLength]="[3]"
                                        required
                                        style="padding-inline-end:45px;">
                                <i *ngIf="isLoading"
                                    class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:20px;"></i>
                                <i *ngIf="!isLoading"
                                    (click)="editCurrency(currency);$event.stopPropagation();"
                                    class="fa fa-check btn-xs btn-outline-primary btn-icon float-right nglist-item-action remove__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:40px;"></i>
                                <i *ngIf="!isLoading"
                                    (click)="resetEdit();$event.stopPropagation();"
                                    class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:20px;"></i>
                            </form>
                        </div>
                        <div class="col-3 align-items-center justify-content-start">
                            <span *ngIf="!editMode[i] || editType !== 'name'" (click)="editMode[i]=true;editType='name';$event.stopPropagation();" style="cursor:pointer;">{{currency.name | translate}}</span>
                            <form *ngIf="editMode[i] && editType === 'name'"
                                    (click)="$event.stopPropagation();"
                                    style="width:100%;display:flex;align-items:center;">
                                <input class="form-control"
                                        type="text"
                                        name="name"
                                        [(ngModel)]="currency.name"
                                        placeholder="{{ 'annexes.currency.name_placeholder' | translate }}"
                                        #name="ngModel"
                                        [rangeLength]="[2, 256]"
                                        required
                                        style="padding-inline-end:45px;">
                                <i *ngIf="isLoading"
                                    class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:20px;"></i>
                                <i *ngIf="!isLoading"
                                    (click)="editCurrency(currency);$event.stopPropagation();"
                                    class="fa fa-check btn-xs btn-outline-primary btn-icon float-right nglist-item-action remove__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:40px;"></i>
                                <i *ngIf="!isLoading"
                                    (click)="resetEdit();$event.stopPropagation();"
                                    class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon"
                                    aria-hidden="true"
                                    style="position:absolute;right:20px;"></i>
                            </form>
                        </div>
                        <div class="col-3 align-items-center justify-content-end">
                            <i class="fas {{currency.isPrefix ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}" style="position:relative;top:2px;" (click)="currency.isPrefix=!currency.isPrefix;editCurrency(currency);$event.stopPropagation();"></i>
                            <i *ngIf="isLoading"
                                class="fa fa-spinner fa-spin services-select__remove services-select__icon"
                                aria-hidden="true"></i>
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                            <confirmation [showTrashIcon]="true"
                                [question]="'confirm.areyousure'"
                                (isConfirmed)="removeCurrency($event, currency.id)"
                                style="position:relative;top:-2px;"></confirmation>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="row">
                        <div class="col-2 align-items-center justify-content-start"></div>
                        <div class="col-2 align-items-center justify-content-start">
                            <ng-select
                                bindLabel="text"
                                bindValue="id"
                                class="w-100"
                                [(ngModel)]="newCurrency"
                                [items]="currencyCodes"
                                (change)="selected($event)"></ng-select>
                        </div>
                        <div class="col-3 align-items-center justify-content-start flex-column">
                            <input class="form-control w-100"
                                type="text"
                                name="name"
                                [(ngModel)]="selectedCurrency.name"
                                placeholder="{{ 'annexes.currency.name_placeholder' | translate }}"
                                #name="ngModel"
                                [rangeLength]="[1, 5]"
                                required />
                                <p class="validation-error"
                                    *ngIf="name.errors?.required && name?.touched">{{ 'form.validate.required' | translate }}</p>
                                <p class="validation-error"
                                    *ngIf="name.errors?.rangeLength">{{ 'form.validate.minLenght' | translate }} 1!</p>
                                <p class="validation-error"
                                    *ngIf="name.errors?.rangeLength">{{ 'form.validate.maxLenght' | translate }} 5!</p>
                        </div>
                        <div class="col-3 align-items-center justify-content-end">
                            <i  class="fas {{selectedCurrency.isPrefix ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}" 
                                style="position:relative;top:2px;" 
                                (click)="selectedCurrency.isPrefix = !selectedCurrency.isPrefix;$event.stopPropagation();"></i>
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                            <button class="editBtn  btn-dark {{ selectedCurrency.name ? '' : 'block' }}"
                                (click)="submit(selectedCurrency);$event.stopPropagation();">{{ 'Add' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
